function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n    "));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "m12.5,0h0C5.6,0,0,5.6,0,12.5h0c0,6.9,5.6,12.5,12.5,12.5h0c6.9,0,12.5-5.6,12.5-12.5h0C25,5.6,19.4,0,12.5,0Zm5.63,11.73c-.56,2.3-2.73,4.69-4.97,4.14-.55-.13-1.08-.4-1.46-.79l-.4,1.66c-.53,2.18-1.55,3.23-1.79,3.46l-.08-.03c-.12-.33-.52-1.73,0-3.88l1.15-4.68c-.28-.38-.42-.97-.24-1.69.3-1.25,1.26-1.67,1.86-1.52.6.15.97.76.82,1.36l-.57,2.33c-.25,1.03-.15,1.94.78,2.17,1.56.38,2.64-1.33,3.02-2.89.53-2.18-.62-4.11-2.5-4.57-2.18-.53-4.74.49-5.35,2.98-.21.87-.07,1.79.56,2.36.09.08.13.2.11.31l-.25,1c-.05.2-.27.3-.45.2-1.76-.93-1.86-2.89-1.54-4.18.9-3.68,4.6-5.21,7.74-4.44,2.72.67,4.37,3.51,3.57,6.73Z"
});

var SvgEroskiFooter3Pinterest = function SvgEroskiFooter3Pinterest(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    id: "pinterest",
    viewBox: "0 0 25 25",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEroskiFooter3Pinterest, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/eroski-footer3-pinterest.acc8221a.svg";
export { ForwardRef as ReactComponent };